import reduxKeys from "../../constants/reduxKeys";

// reducers.js
const initialState = {
  data: {},
  token: localStorage.getItem("access_token"),
  // Pages will be stored here
  allowedPageNames: [],
  dealerData: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case reduxKeys.SET_USER_DATA:
      return { ...state, data: action.payload, token: action.payload.token ?? null };
    case reduxKeys.SET_ALLOWED_PAGES:
      return { ...state, allowedPageNames: action.payload };
    case reduxKeys.SET_PROFILE:
      return { ...state, dealerData: action.payload };
    default:
      return state;
  }
};

export default reducer;